import { isValidBIC } from 'ibantools';
import { addMethod, string } from 'yup';

addMethod(string, 'bic', function (message) {
  return this.test('bic-test', message, (value) => isValidBIC(value ?? 'null'));
});
